<app-auth-header [title]="title" [subtitle]="subtitle"></app-auth-header>
<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <section i18n-aria-label aria-label="Login form">
    <div class="form-group">
      <div class="p-inputtext-lg">
        <label for="password" class="sr-only">{{ 'AUTH.FIELDS.NEW_PASSWORD' | translate }}</label>
        <p-password
          [placeholder]="'AUTH.FIELDS.NEW_PASSWORD' | translate"
          id="password"
          [feedback]="false"
          styleClass="p-password p-component p-inputwrapper p-input-icon-right"
          required
          formControlName="password"
        ></p-password>
      </div>
    </div>
  </section>
  <section i18n-aria-label aria-label="Login form">
    <div class="form-group">
      <div class="p-inputtext-lg">
        <label for="password_repeat" class="sr-only">{{ 'AUTH.FIELDS.REPEAT_NEW_PASSWORD' | translate }}</label>
        <p-password
          [placeholder]="'AUTH.FIELDS.NEW_PASSWORD_REPEAT' | translate"
          id="password_repeat"
          [feedback]="false"
          styleClass="p-password p-component p-inputwrapper p-input-icon-right"
          required
          formControlName="confirmPassword"
        ></p-password>
      </div>
    </div>
  </section>
  <div>
    <div class="space"></div>
    <button type="submit" class="btn btn-primary lg">{{ 'AUTH.APPLY_RESET.SET_NEW_PASSWORD' | translate }}</button>
    <footer>
      <p class="forgot-line text-center">
        <a i18n [routerLink]="['../', 'login']">{{ 'AUTH.FOOTER.BACK_TO_LOGIN' | translate }}</a>
      </p>
    </footer>
    <div class="space"></div>
    <p class="dont-have-account text-center">
      {{ 'AUTH.LOGIN.DONT_HAVE_ACCOUNT' | translate }} <a>{{ 'AUTH.LOGIN.CREATE_NOW' | translate }}</a>
    </p>
  </div>
</form>
